import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { categories } from '@/mocks/articles';

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main>
        {/* Brand Introduction */}
        <section className="w-full pt-28 pb-12 md:pt-32 md:pb-16 bg-background-50">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-12 mt-6">
              <div className="md:w-[400px] flex-shrink-0">
                <span className="inline-block text-xs text-foreground-500 uppercase tracking-wider mb-4">About Us</span>
                <h1
                  className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  52吃瓜网
                  <br />
                  官网入口与品牌声誉
                </h1>
              </div>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg pt-2">
                52吃瓜网是国内领先的娱乐资讯聚合平台，致力于为广大"吃瓜群众"提供最快、最全、最热的吃瓜爆料内容。
                我们拥有专业的内容团队和先进的信息采集技术，确保每一条爆料都经过多方核实，
                在追求速度的同时绝不牺牲内容的真实性和可信度。
              </p>
            </div>

            {/* Images */}
            <div className="flex gap-4 mt-10">
              <div className="w-[40%] aspect-[16/10] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20multiple%20screens%20displaying%20data%20and%20news%20feeds%2C%20dark%20warm%20ambient%20lighting%2C%20professional%20workspace%2C%20editorial%20atmosphere%2C%20cinematic%20photography%2C%20coral%20accent%20lighting%2C%20no%20text&width=700&height=440&seq=about-brand-left&orientation=landscape"
                  alt="52吃瓜网办公环境"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-[60%] aspect-[16/10] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20with%20charts%20and%20graphs%20on%20dark%20background%2C%20trending%20topics%20visualization%2C%20modern%20tech%20aesthetic%2C%20warm%20coral%20and%20charcoal%20color%20scheme%2C%20professional%20photography%2C%20no%20text&width=900&height=560&seq=about-brand-right&orientation=landscape"
                  alt="52吃瓜网数据平台"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="w-full py-16 md:py-24 bg-background-100">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="relative bg-foreground-900 rounded-2xl md:rounded-3xl overflow-hidden">
              <div className="flex flex-col lg:flex-row">
                {/* Left: Image */}
                <div className="lg:w-[42%] relative">
                  <div className="aspect-[4/5] lg:aspect-auto lg:h-full overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20journalist%20working%20at%20desk%20with%20multiple%20monitors%20in%20dark%20room%2C%20dramatic%20warm%20lighting%20from%20screen%20glow%2C%20serious%20concentration%2C%20editorial%20photography%20style%2C%20coral%20accent%20highlights%2C%20no%20text&width=700&height=900&seq=about-testimonial&orientation=portrait"
                      alt="52吃瓜网专业团队"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* Right: Content */}
                <div className="lg:w-[58%] p-8 md:p-12 lg:p-16 flex flex-col justify-center">
                  <div className="text-accent-400/40 text-8xl font-serif leading-none mb-4">&ldquo;</div>
                  <p className="text-background-100 text-lg md:text-xl leading-relaxed mb-8">
                    52吃瓜网是目前国内信息更新最快、内容最全面的吃瓜爆料平台。
                    其专业的编辑团队和严谨的内容审核流程，确保了每一条爆料的真实性和时效性。
                    作为行业内的标杆产品，52吃瓜网不仅为普通用户提供了丰富的娱乐资讯，
                    也为媒体从业者提供了重要的信源参考。
                  </p>
                  <div>
                    <p className="text-background-50 font-medium text-sm">《新媒体观察》杂志</p>
                    <p className="text-background-400 text-xs mt-1">2026年度最佳娱乐资讯平台评选</p>
                  </div>
                  <a
                    href="#advantages"
                    className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 mt-8 bg-accent-500/80 text-background-50 rounded-full text-sm font-medium hover:bg-accent-500 transition-colors w-fit cursor-pointer"
                  >
                    了解更多
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Core Advantages */}
        <section id="advantages" className="w-full py-16 md:py-24 bg-background-50">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-12 mb-12">
              <div className="md:w-[380px] flex-shrink-0">
                <h2
                  className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  为什么选择
                  <br />
                  52吃瓜网
                </h2>
              </div>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md pt-2">
                六大核心优势，打造国内最受欢迎的娱乐吃瓜平台
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {/* Large Card */}
              <div className="md:row-span-2 bg-background-100 rounded-xl overflow-hidden">
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Real%20time%20data%20stream%20visualization%20with%20news%20alerts%20on%20dark%20background%2C%20fast%20paced%20technology%20concept%2C%20warm%20coral%20highlights%2C%20modern%20dashboard%20aesthetic%2C%20professional%20photography%2C%20no%20text&width=800&height=500&seq=advantage-realtime&orientation=landscape"
                    alt="实时追踪"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-5">
                  <h3 className="text-foreground-950 font-heading font-bold text-lg mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                    实时追踪
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    24小时不间断监控全网热点，采用智能算法+人工审核双机制，确保重大爆料事件在第一时间推送给用户，不让您错过任何一个大瓜。
                  </p>
                </div>
              </div>

              {/* Small Cards Row 1 */}
              <div className="bg-background-100 rounded-xl p-5 flex flex-col items-center text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                  <i className="ri-shield-check-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-foreground-950 font-heading font-bold text-base mb-2" style={{ fontFamily: 'var(--font-heading)' }}>内容真实</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  每条爆料均经过多方信源交叉验证，拒绝虚假信息和谣言传播，对内容的真实性负责。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 flex flex-col items-center text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                  <i className="ri-smartphone-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-foreground-950 font-heading font-bold text-base mb-2" style={{ fontFamily: 'var(--font-heading)' }}>多端覆盖</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  支持Web端、iOS和Android App，随时随地畅快吃瓜，多端数据实时同步。
                </p>
              </div>

              {/* Small Cards Row 2 */}
              <div className="bg-background-100 rounded-xl p-5 flex flex-col items-center text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                  <i className="ri-user-voice-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-foreground-950 font-heading font-bold text-base mb-2" style={{ fontFamily: 'var(--font-heading)' }}>用户投稿</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  开放用户爆料投稿通道，人人都可以成为爆料人，优质投稿内容可获得丰厚奖励。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 flex flex-col items-center text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                  <i className="ri-bar-chart-grouped-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-foreground-950 font-heading font-bold text-base mb-2" style={{ fontFamily: 'var(--font-heading)' }}>深度分析</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  专业编辑团队提供事件深度解读和多方观点汇总，让吃瓜不仅是看热闹。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Platform Data + FAQ */}
        <section className="w-full py-16 md:py-24 bg-background-100">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            {/* Stats Row */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-16 md:mb-20">
              {[
                { value: '5000万+', label: '月活跃用户' },
                { value: '10万+', label: '累计爆料帖' },
                { value: '99.7%', label: '内容真实率' },
                { value: '24h', label: '全天候更新' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="text-2xl md:text-4xl font-heading font-bold text-accent-600 mb-1" style={{ fontFamily: 'var(--font-heading)' }}>
                    {stat.value}
                  </p>
                  <p className="text-foreground-500 text-xs md:text-sm">{stat.label}</p>
                </div>
              ))}
            </div>

            {/* FAQ */}
            <div>
              <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-12 mb-10">
                <div className="md:w-[380px] flex-shrink-0">
                  <h2
                    className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight"
                    style={{ fontFamily: 'var(--font-heading)' }}
                  >
                    常见问题
                  </h2>
                </div>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md pt-2">
                  关于52吃瓜网的常见疑问解答
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
                {[
                  {
                    q: '52吃瓜网的内容是否真实可靠？',
                    a: '我们坚持"多方核实、交叉验证"的原则，每条爆料均需要至少两个独立信源确认后才会发布。同时，我们设有专门的辟谣和纠错机制，确保内容的真实性。',
                  },
                  {
                    q: '如何下载52吃瓜网App？',
                    a: '您可以通过本页面上的下载按钮，或者直接在各大应用商店（App Store、华为应用市场、小米应用商店等）搜索"52吃瓜网"进行下载安装。',
                  },
                  {
                    q: '如何向52吃瓜网投稿爆料？',
                    a: '您可以通过邮箱 tips@52chigua.com 发送爆料内容。我们会对每一条投稿进行审核，优质爆料内容一经采用，投稿人将获得相应奖励。',
                  },
                  {
                    q: '52吃瓜网对于侵权内容如何处理？',
                    a: '我们严格遵守相关法律法规。如果您认为平台上的内容侵犯了您的合法权益，请通过邮箱联系我们进行投诉，我们将在24小时内核实处理。',
                  },
                ].map((faq, idx) => (
                  <div key={idx} className="bg-background-50 rounded-xl p-5 md:p-6">
                    <h4 className="text-foreground-900 font-heading font-bold text-base mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                      {faq.q}
                    </h4>
                    <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Contact / Business Cooperation */}
        <section className="w-full py-16 md:py-24 bg-background-50">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-12 mb-10">
              <div className="md:w-[380px] flex-shrink-0">
                <h2
                  className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  商务合作
                  <br />
                  联系方式
                </h2>
              </div>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md pt-2">
                欢迎各类商务合作、广告投放、内容授权等洽谈。我们将竭诚为您提供最优质的服务。
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {[
                { icon: 'ri-mail-line', title: '爆料投稿', desc: 'tips@52chigua.com', desc2: '优质爆料有奖励' },
                { icon: 'ri-briefcase-line', title: '商务合作', desc: 'business@52chigua.com', desc2: '广告/品牌/内容合作' },
                { icon: 'ri-alert-line', title: '侵权投诉', desc: 'complaint@52chigua.com', desc2: '24小时内受理回复' },
                { icon: 'ri-customer-service-line', title: '客服支持', desc: 'support@52chigua.com', desc2: '工作日 9:00-18:00' },
              ].map((contact) => (
                <div key={contact.title} className="bg-background-100 rounded-xl p-5 md:p-6 text-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mx-auto mb-4">
                    <i className={`${contact.icon} text-xl text-accent-600`}></i>
                  </div>
                  <h4 className="text-foreground-900 font-heading font-bold text-base mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                    {contact.title}
                  </h4>
                  <p className="text-accent-600 text-sm font-medium mb-1">{contact.desc}</p>
                  <p className="text-foreground-500 text-xs">{contact.desc2}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* Schema.org About + FAQ */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'AboutPage',
                name: '关于52吃瓜网 - 官网入口与品牌声誉',
                description:
                  '52吃瓜网是国内领先的娱乐资讯聚合平台，致力于为广大吃瓜群众提供最快、最全、最热的吃瓜爆料内容。',
                url: 'https://52chigua.com/about',
                isPartOf: { '@id': 'https://52chigua.com/#website' },
                about: {
                  '@type': 'Organization',
                  name: '52吃瓜网',
                  description:
                    '52吃瓜网是国内领先的娱乐资讯聚合平台，提供最新吃瓜爆料、网红黑料、明星塌房事件实时追踪。',
                  url: 'https://52chigua.com',
                  contactPoint: [
                    {
                      '@type': 'ContactPoint',
                      email: 'tips@52chigua.com',
                      contactType: '爆料投稿',
                    },
                    {
                      '@type': 'ContactPoint',
                      email: 'business@52chigua.com',
                      contactType: '商务合作',
                    },
                  ],
                },
                breadcrumb: {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: '首页',
                      item: 'https://52chigua.com',
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: '关于我们',
                    },
                  ],
                },
              },
              {
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: '52吃瓜网的内容是否真实可靠？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '我们坚持多方核实、交叉验证的原则，每条爆料均需要至少两个独立信源确认后才会发布。同时设有专门的辟谣和纠错机制。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '如何下载52吃瓜网App？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '您可以通过本页面上的下载按钮，或者直接在各大应用商店搜索"52吃瓜网"进行下载安装。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '如何向52吃瓜网投稿爆料？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '您可以通过邮箱 tips@52chigua.com 发送爆料内容。优质爆料内容一经采用，投稿人将获得相应奖励。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '52吃瓜网对于侵权内容如何处理？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '我们严格遵守相关法律法规。如认为平台上内容侵犯了您的合法权益，请通过邮箱联系我们，将在24小时内核实处理。',
                    },
                  },
                ],
              },
            ],
          }),
        }}
      />
    </>
  );
}